import { useQuery } from '@redwoodjs/web';

import { GET_SERVICE_APPLICATION } from 'src/graphql/queries/getAddServiceApplication.query';

const useServiceApplication = (
    merchantAccountNumber,
    serviceApplication,
    setActiveStep,
    setServiceApplication
) => {
    const {
        data: _,
        loading,
        error,
    } = useQuery(GET_SERVICE_APPLICATION, {
        fetchPolicy: 'network-only',
        skip: !merchantAccountNumber || !!serviceApplication,
        variables: {
            merchantAccountNumber,
        },
        onCompleted: (data) => {
            if (data?.retrieveMerchantServiceApplication === undefined) {
                setActiveStep(0);
            } else {
                setServiceApplication(data?.retrieveMerchantServiceApplication);
                setActiveStep(1);
            }
        },
    });

    return { loading, error };
};

export default useServiceApplication;
